import { AsyncStateNotification } from '@ui/notifications';
import { coreActions } from '@sonar-software/sonar-core';
import { createSonarSelector } from '@lib/selectors';
import { EditTag } from './EditTag';
import { NoData } from '@ui/NoData';
import React from 'react';
import { SonarCard } from '@ui/general';
import { useTags } from '@hooks';
import { When } from 'react-if';

import { COPY_SPECIFIC, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';

const updateTagSelector = createSonarSelector((state) => state.core.tags.byId.put);
const deleteTagSelector = createSonarSelector((state) => state.core.tags.byId.delete);

export const EditTags: React.FC = () => {
	const tags = useTags(true);

	return (
		<>
			<SonarCard
				className='tag-edit-card'
				title={ COPY_SPECIFIC.EDIT_TAGS }>
				<When condition={ tags.length === 0 }>
					<NoData description={ COPY_SPECIFIC.NO_TAGS } />
				</When>
				{ tags.map((tag) =>
					<EditTag
						key={ tag.id }
						tag={ tag } />) }
			</SonarCard>
			<AsyncStateNotification
				errored={ NOTIFICATIONS_COPY.ERROR_PUT_TAG }
				failed={ NOTIFICATIONS_COPY.FAILED_PUT_TAG }
				received={ NOTIFICATIONS_COPY.SUCCESS_PUT_TAG }
				resetRawAction={ coreActions.resetPutCoreTagsById }
				stateSelector={ updateTagSelector } />
			<AsyncStateNotification
				errored={ NOTIFICATIONS_COPY.ERROR_DELETE_TAG }
				failed={ NOTIFICATIONS_COPY.FAILED_DELETE_TAG }
				received={ NOTIFICATIONS_COPY.SUCCESS_DELETE_TAG }
				resetRawAction={ coreActions.resetDeleteCoreTagsById }
				stateSelector={ deleteTagSelector } />
		</>
	);
};
